import create from "zustand";
import { persist } from "zustand/middleware";

interface AdminPrefState {
  orgIdOverride: string | null;
  setOrgIdOverride: (orgIdOverride: string | null) => void;
}

const adminPrefStore = create<AdminPrefState>()(
  persist(
    (set) => ({
      orgIdOverride: null,
      setOrgIdOverride: (orgIdOverride) => set(() => ({ orgIdOverride })),
    }),
    {
      name: "admin-pref",
    }
  )
);
export default adminPrefStore;
